__webpack_require__.p = "https://smartflow.stage.coor.digital/";